export default class TableOfContent{
	constructor() {
		this.nav = document.querySelector('[data-nav]');

        if (!this.nav) {
            return;
        }

        let navItems = document.querySelectorAll('[data-navitem]');

        navItems.forEach(item => {

            const li = document.createElement('li');
            const name = item.dataset.navitem;

            li.innerHTML = `<a class="m-toc__nav-link" href="#${item.id}">${name}</a>`;

            this.nav.appendChild(li);
        });
	}
}
